import { useCachedFlag, type CachedFlag } from '../providers/CachedFlagsProvider'

export default function useSourceCentricDetailsFlag(): CachedFlag<'sourceCentricDetails'> {
  return useCachedFlag('sourceCentricDetails')
}
